(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.product-section-refresh"] && !Shopify.designMode) return;
  try {
    /*============================================================================
    kit-section-refresh
    - Listens for `shopify:product:select` with `{detail: {html}}` section payload
    - Supports only server-rendered markup (no inputs or other dynamic content)
    - Use `data-kit-refresh="<name>"` to mark the regions to replace

    Replaces the variant-dependent regions of a product section with the
    server-rendered markup the variant picker already fetched, so a theme does
    not need client-side code to recompute price, inventory, SKU or button state.
  ==============================================================================*/

  if (!customElements.get('kit-section-refresh')) {
    class KitSectionRefresh extends HTMLElement {
      #selectionId = 0;
      #abortController = null;

      get sectionId() {
        return this.dataset.sectionId;
      }

      get productId() {
        return this.dataset.productId;
      }

      get root() {
        const selector = this.dataset.root;

        if (selector) return this.closest(selector);

        return this.closest('.shopify-section');
      }

      connectedCallback() {
        this.#abortController = new AbortController();

        document.addEventListener('shopify:product:select', event => this.#select(event), {
          signal: this.#abortController.signal,
        });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
      }

      #owns(picker) {
        if (!(picker instanceof HTMLElement) || !picker.matches('kit-variant-picker')) return false;
        if (this.sectionId && picker.dataset.sectionId !== this.sectionId) return false;
        if (this.productId && picker.dataset.productId !== this.productId) return false;

        return true;
      }

      async #select(event) {
        const picker = event.target;
        const root = this.root;

        if (!this.#owns(picker)) return;

        if (!root) {
          console.warn('Section refresh: no root element to refresh within.', this);
          return;
        }

        const selectionId = ++this.#selectionId;
        this.#setBusy(root, true);

        try {
          const result = await event.promise;

          // A newer selection owns the outcome
          if (selectionId !== this.#selectionId) return;

          // Follow the picker to its new product (combined listings)
          this.dataset.productId = picker.dataset.productId;

          const regionMap = this.#fetchedRegions(result);

          if (!regionMap) {
            console.warn('Section refresh: the variant picker resolved without a section document.', result);
            return;
          }

          this.#apply(root, regionMap, picker);
        } catch (error) {
          if (error?.name === 'AbortError') return;
          if (selectionId !== this.#selectionId) return;

          console.error('Section refresh failed:', error);
        } finally {
          if (selectionId === this.#selectionId) this.#setBusy(root, false);
        }
      }

      #fetchedRegions(result) {
        const html = result?.detail?.html;

        if (!html) return null;

        const selector = this.dataset.root;
        const scope = selector ? html.querySelector(selector) : html;

        if (!scope) {
          console.warn(`Section refresh: root "${selector}" not found in the fetched section.`, html);
          return null;
        }

        const byName = new Map();

        scope.querySelectorAll('[data-kit-refresh]').forEach(element => {
          const name = element.dataset.kitRefresh;

          if (!byName.has(name)) byName.set(name, []);

          // Instances (e.g. mobile + desktop copies) accessible by index
          byName.get(name).push(element);
        });

        return byName;
      }

      #apply(root, fetchedRegions, picker) {
        const counts = new Map();

        root.querySelectorAll('[data-kit-refresh]').forEach(target => {
          const name = target.dataset.kitRefresh;
          const instanceIndex = counts.get(name) ?? 0;
          counts.set(name, instanceIndex + 1);

          // Skip picker itself
          if (picker.contains(target) || target.contains(picker)) return;

          const source = fetchedRegions.get(name)?.[instanceIndex];

          if (!source) return;

          // Cloned to allow re-use of the source element
          target.replaceWith(source.cloneNode(true));
        });
      }

      #setBusy(root, busy) {
        if (busy) {
          root.setAttribute('data-kit-refresh-busy', '');
          root.setAttribute('aria-busy', 'true');
        } else {
          root.removeAttribute('data-kit-refresh-busy');
          root.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('kit-section-refresh', KitSectionRefresh);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.product-variant-picker"] && !Shopify.designMode) return;
  try {
    /*============================================================================
    kit-variant-picker
    - For quick shop, fetch the full merchant-configured product page and set
    the correct section id on the picker

    Events:
    - shopify:product-select
    - kit:variant-picker:change (legacy)
    - kit:variant-picker:after-change (legacy)
    - kit:variant-picker:error (legacy)
  ==============================================================================*/

  if (!customElements.get('kit-variant-picker')) {
    class KitVariantPicker extends HTMLElement {
      #abortController = null;
      #standardEventsReady = null;
      // Prevents race conditions between completed requests
      #selectionId = 0;
      #chosenOptions = new Map();

      get sectionId() {
        return this.dataset.sectionId;
      }

      set sectionId(value) {
        this.dataset.sectionId = value;
      }

      connectedCallback() {
        this.#readIdentity();
        this.selectedVariant = JSON.parse(this.querySelector('[data-kit-selected-variant]')?.textContent ?? 'null');
        this.shouldUpdateUrl = 'updateUrl' in this.dataset;
        this.allowUnselected = 'allowUnselected' in this.dataset;
        this.soldOutLabelTemplate = this.querySelector('template[data-sold-out-label-template]');
        this.soldOutLabel = this.soldOutLabelTemplate.content.querySelector('[data-sold-out-label]').textContent;
        this.#resolveAvailability();
        this.#echoChoices();
        this.#standardEventsReady = this.#loadStandardEvents();
        this.addEventListener('change', this.#onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.#onChange);
        this.#abortController?.abort();
      }

      #readIdentity(el = this) {
        this.productId = el.dataset.productId;
        this.productTitle = el.dataset.productTitle;
        this.productHandle = el.dataset.productHandle;
        this.productUrl = el.dataset.productUrl;
        this.variantId = el.dataset.variantId;

        if (el !== this) {
          this.dataset.productId = el.dataset.productId;
          this.dataset.productTitle = el.dataset.productTitle;
          this.dataset.productHandle = el.dataset.productHandle;
          this.dataset.productUrl = el.dataset.productUrl;
          this.dataset.variantId = el.dataset.variantId;
        }
      }

      async #loadStandardEvents() {
        try {
          this.SE = await import('https://cdn.shopify.com/storefront/standard-events.js');
        } catch (error) {
          console.error('Failed to load the Shopify Standard Events module.', error);
        }
      }

      async #onChange(event) {
        const trigger = event.target;

        if (!(trigger instanceof HTMLElement) || !trigger.matches('input[type="radio"], select')) {
          return;
        }

        const selectedOption = trigger.tagName === 'SELECT'
          ? trigger.options[trigger.selectedIndex]
          : trigger.closest('[data-option-value-id]');
        const optionValueId = selectedOption?.dataset.optionValueId;
        const productUrl = selectedOption?.dataset.productUrl;
        const previous = {
          product: this.#product(),
          variantId: this.variantId
        };

        // Remember the selections and check if all options are chosen (for unselected picker)
        let incomplete = false;
        if (this.allowUnselected) {
          this.#getSelectedOptions().forEach(option => this.#chosenOptions.set(option.name, option.id));
          incomplete = this.selectionIncomplete;
        }

        const deferred = await this.#dispatchChange(productUrl, previous, incomplete);
        if (!deferred) return;

        const selectionId = ++this.#selectionId;

        try {
          const html = await this.#refresh(optionValueId, productUrl, selectionId, incomplete);
          const viewEventPayloadEl = html.querySelector('kit-variant-picker [data-view-event-payload]');
          const viewPayload = JSON.parse(viewEventPayloadEl?.textContent?.trim() ?? 'null');
          const viewEventVariant = viewPayload?.product?.selectedVariant ?? null;

          this.#dispatchAfterChange(html, this.selectedVariant, viewEventVariant, deferred, previous);
        } catch (error) {
          deferred.reject(error);

          // Ignore errors triggered by aborted/superseded requests
          if (error.name === 'AbortError') return;
          if (selectionId !== this.#selectionId) return;

          console.error(error);
          this.#dispatchError(error, productUrl, previous);
        }
      }

      async #refresh(changedOptionValueId, productUrl, selectionId, incomplete) {
        const sectionRequestUrl = this.#variantUrl(productUrl);
        sectionRequestUrl.searchParams.set('section_id', this.sectionId);

        this.#abortController?.abort();
        const refreshAbortController = new AbortController();
        this.#abortController = refreshAbortController;

        this.#setLoading();
        try {
          const sectionRequest = await fetch(sectionRequestUrl, { signal: refreshAbortController.signal });

          if (!sectionRequest.ok) {
            throw new Error(`Variant section request failed with ${sectionRequest.status}`);
          }

          const sectionResponse = await sectionRequest.text();
          const sectionHtml = new DOMParser().parseFromString(sectionResponse, 'text/html');
          const newPicker = sectionHtml.querySelector('kit-variant-picker');

          if (!newPicker) {
            throw new Error('<kit-variant-picker> not found');
          }

          // In case a new request begins after the current request can be aborted
          if (selectionId !== this.#selectionId) {
            throw new DOMException('Superseded by a newer selection', 'AbortError');
          }

          this.innerHTML = newPicker.innerHTML;
          this.#readIdentity(newPicker);
          this.selectedVariant = JSON.parse(this.querySelector('[data-kit-selected-variant]')?.textContent ?? 'null');
          this.#reconcileSelections();
          this.#resolveAvailability();
          this.#echoChoices();

          if (incomplete) {
            this.variantId = '';
            this.dataset.variantId = '';
            this.selectedVariant = null;
            this.querySelector('[data-variants]')?.remove();
          }

          this.#restoreFocus(changedOptionValueId);
          this.#updateHistory(this.variantId, productUrl);

          return sectionHtml;
        } finally {
          // Clear loading state if the current request was not superseded
          if (selectionId === this.#selectionId) {
            this.#unsetLoading();
          }
        }
      }

      async #dispatchChange(productUrl, previous, incomplete) {
        const changeEvent = this.#emit('change', {
          picker: this,
          previousVariant: previous.variantId,
          product: previous.product,
          sectionId: this.sectionId,
          selectedOptions: this.#getSelectedOptions().map(({ name, value }) => ({ name, value })),
          selectionIncomplete: incomplete
        }, { cancelable: true });

        if (changeEvent.defaultPrevented) return null;

        // Unselected: still refresh to narrow availability, but no variant reporting
        if (incomplete) return { resolve() { }, reject() { } };

        await this.#standardEventsReady;
        if (!this.SE?.ProductSelectEvent) {
          this.#navigate(productUrl);
          return null;
        }

        const deferred = this.SE.ProductSelectEvent.createPromise();
        this.#standardDispatch({ promise: deferred.promise });
        return deferred;
      }

      #dispatchAfterChange(html, selectedVariant, viewEventVariant, deferred, previous) {
        this.#emit('after-change', {
          html,
          picker: this,
          previousProduct: previous.product,
          previousVariant: previous.variantId,
          product: this.#product(),
          productChanged: previous.product.id !== this.productId,
          sectionId: this.sectionId,
          selectedOptions: this.#getSelectedOptions().map(({ name, value }) => ({ name, value })),
          selectionIncomplete: this.selectionIncomplete,
          variant: selectedVariant
        });

        deferred.resolve({
          detail: { html },
          variant: viewEventVariant
        });
      }

      #dispatchError(error, productUrl, previous) {
        const errorEvent = this.#emit('error', {
          error,
          picker: this,
          previousVariant: previous.variantId,
          product: previous.product,
          sectionId: this.sectionId
        }, { cancelable: true });

        if (!errorEvent.defaultPrevented) {
          this.#navigate(productUrl);
        }
      }

      #standardDispatch({ promise }) {
        const selectedOptions = this.#getSelectedOptions().map(({ name, value }) => {
          return { name, value };
        });

        this.dispatchEvent(new this.SE.ProductSelectEvent({
          selectedOptions,
          product: {
            id: this.productId,
            title: this.productTitle,
            handle: this.productHandle
          },
          promise
        }));
      }

      #product() {
        return {
          id: this.productId,
          title: this.productTitle,
          handle: this.productHandle,
          url: this.productUrl
        };
      }

      #emit(type, detail, { cancelable = false } = {}) {
        const event = new CustomEvent(`kit:variant-picker:${type}`, {
          bubbles: true,
          cancelable,
          detail
        });

        this.dispatchEvent(event);
        return event;
      }

      #navigate(productUrl) {
        const url = this.#variantUrl(productUrl);

        this.#setLoading();
        window.location.assign(url.toString());
      }

      get selectionIncomplete() {
        if (!this.allowUnselected) return false;

        const names = new Set();
        const chosen = new Set();

        this.querySelectorAll('[data-option-name]').forEach(el => {
          const { optionName } = el.dataset;

          names.add(optionName);

          const isChosen = el.tagName === 'SELECT'
            ? el.value !== ''
            : el.querySelector('input[type="radio"]:checked') !== null;

          if (isChosen) chosen.add(optionName);
        });

        return chosen.size < names.size;
      }

      #getSelectedOptions() {
        return [...this.querySelectorAll('input[type="radio"]:checked, select')].map(el => {
          if (el.tagName === 'SELECT') {
            return {
              name: el.dataset.optionName,
              value: el.options[el.selectedIndex]?.value,
              id: el.options[el.selectedIndex]?.dataset.optionValueId
            };
          } else if (el.tagName === 'INPUT') {
            return {
              name: el.closest('[data-option-name]')?.dataset.optionName,
              value: el.value,
              id: el.closest('[data-option-value-id]')?.dataset.optionValueId
            };
          }
        }).filter(option => option.name && option.value && option.id);
      }

      // Since refresh resolves some variant, clear selections that were not chosen
      #reconcileSelections() {
        if (!this.allowUnselected) return;

        [...this.querySelectorAll('[data-option-name]')].forEach(el => {
          const chosenValueId = this.#chosenOptions.get(el.dataset.optionName);

          if (el.tagName === 'SELECT') {
            const match = chosenValueId
              && [...el.options].find(option => option.dataset.optionValueId === chosenValueId);

            if (match) {
              el.value = match.value;
            } else {
              const placeholder = [...el.options].find(option => option.value === '');
              if (placeholder) placeholder.disabled = false;
              el.value = '';
            }
          } else {
            const input = el.querySelector('input[type="radio"]');
            if (input) input.checked = Boolean(chosenValueId) && el.dataset.optionValueId === chosenValueId;
          }
        });
      }

      // Proper availability resolution for incomplete selections (Shopify defaults to a fallback variant's values)
      #resolveAvailability() {
        if (!this.selectionIncomplete && this.selectedVariant) return;

        const availableOptions = JSON.parse(this.querySelector('[data-kit-available-options]')?.textContent ?? 'null');

        // High-variant products and combined listings
        if (!availableOptions) {
          this.#resetUnresolvedAvailability();
          return;
        }

        // With nothing chosen, the server already rated every value against these variants
        const anyChosen = [...this.querySelectorAll('fieldset')].some(fieldset => this.#chosenValue(fieldset) !== null);
        if (anyChosen) this.#applyTrueAvailability(availableOptions);
      }

      #applyTrueAvailability(availableOptions) {
        const chosen = [];

        this.querySelectorAll('fieldset').forEach((fieldset, index) => {
          const matchesEarlierChoices = options => chosen.every((chosenValue, i) => {
            const isUnchosen = chosenValue === null;
            const isMatchingChoice = options[i] === chosenValue;

            return isUnchosen || isMatchingChoice;
          });

          // Mark available if the combination with earlier choices belongs to an available variant
          this.#markAvailability(fieldset, value => {
            return availableOptions.some(options => {
              const isMatchingValue = options[index] === value;

              return isMatchingValue && matchesEarlierChoices(options);
            });
          });

          chosen.push(this.#chosenValue(fieldset));
        });
      }

      // Resets availability for unresolved options
      #resetUnresolvedAvailability() {
        let earlierChosen = true;

        this.querySelectorAll('fieldset').forEach(fieldset => {
          if (!earlierChosen) this.#markAvailability(fieldset, () => true);

          earlierChosen = earlierChosen && this.#chosenValue(fieldset) !== null;
        });
      }

      #chosenValue(fieldset) {
        const select = fieldset.querySelector('select');

        return select
          ? select.value || null
          : fieldset.querySelector('input[type="radio"]:checked')?.value ?? null;
      }

      #markAvailability(fieldset, isAvailable) {

        fieldset.querySelectorAll('option:not([value=""])').forEach(option => {
          const available = isAvailable(option.value);

          option.textContent = available ? option.value : `${option.value}${this.soldOutLabel}`;
        });

        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          const available = isAvailable(input.value);
          const radio = input.closest('[data-option-value-id]');

          radio?.querySelector('.kit-button')?.classList.toggle('kit-button--disabled', !available);
          radio?.querySelector('.kit-swatch')?.classList.toggle('kit-swatch--disabled', !available);

          // Keeps the screen-reader sold-out label in step with the visual marking
          const label = radio?.querySelector('[data-sold-out-label]');
          if (available) {
            label?.remove();
          } else if (!label) {
            radio?.append(this.soldOutLabelTemplate.content.cloneNode(true));
          }
        });
      }

      #echoChoices() {
        this.querySelectorAll('input[type="radio"]:checked').forEach(input => {
          const selection = input.closest('fieldset')?.querySelector('.kit-fieldset__legend-selection');

          if (selection) selection.textContent = input.value;
        });
      }

      #variantUrl(productUrl) {
        const url = new URL(productUrl || this.productUrl, window.location.origin);
        const optionValues = this.#getSelectedOptions()
          .map(option => option.id)
          .join(',');

        url.searchParams.set('option_values', optionValues);
        return url;
      }

      #updateHistory(variantId, productUrl) {
        if (!this.shouldUpdateUrl || window.Shopify?.designMode) return;

        const url = new URL(window.location.href);

        if (productUrl) {
          url.pathname = new URL(productUrl, window.location.origin).pathname;
        }

        if (variantId) {
          url.searchParams.set('variant', variantId);
        } else {
          url.searchParams.delete('variant');
        }

        window.history.replaceState({}, '', url.toString());
      }

      #restoreFocus(optionValueId) {
        const option = this.querySelector(`[data-option-value-id="${optionValueId}"]`);

        if (!option) return;
        if (option.tagName === 'OPTION' && !matchMedia('(pointer: coarse)').matches) {
          option.closest('select')?.focus();
        } else {
          (option.querySelector('input') || option).focus();
        }
      }

      #setLoading() {
        this.classList.add('kit-picker--loading');
      }

      #unsetLoading() {
        this.classList.remove('kit-picker--loading');
      }
    }

    customElements.define('kit-variant-picker', KitVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.tooltip"] && !Shopify.designMode) return;
  try {
    const FLIPS = { top: 'bottom', bottom: 'top', start: 'end', end: 'start' };
  const VIEWPORT_MARGIN = 4;
  const MIN_ARROW_INSET = 12;
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

  // After one tooltip is shown, neighbouring triggers open instantly for a short period.
  const WARM_WINDOW = 300;
  let warmUntil = 0;

  // Only one tooltip on the page is open at a time
  let openTooltip = null;

  class KitTooltip extends HTMLElement {
    #abortController = null;
    #openAbortController = null;
    #showTimeout = null;
    #placement = String();
    #delay = Number();
    #showOnFocus = Boolean();
    #isRTL = Boolean();
    #trigger = null;
    #bubble = null;

    connectedCallback() {
      this.#placement = this.getAttribute('placement') || 'top';
      this.#delay = Number(this.getAttribute('delay')) || 0;
      this.#showOnFocus = this.getAttribute('show-on-focus') !== 'false';
      this.#trigger = this.querySelector('.kit-tooltip__trigger');
      this.#bubble = this.querySelector('.kit-tooltip__bubble');
      this.#isRTL = getComputedStyle(this).direction === 'rtl';

      if (this.#isRTL && !this.matches(':dir(rtl)')) this.setAttribute('dir', 'rtl');

      if (!this.#trigger || !this.#bubble) return;

      this.#wireDescription();

      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#trigger.addEventListener('mouseenter', () => this.#scheduleShow(), { signal });
      this.#trigger.addEventListener('mouseleave', () => this.#hide(), { signal });
      this.#trigger.addEventListener('focusout', () => this.#hide(), { signal });

      if (this.#showOnFocus) {
        this.#trigger.addEventListener(
          'focusin',
          (event) => {
            if (event.target instanceof Element && event.target.matches(':focus-visible')) this.#show();
          },
          { signal }
        );
      }

      // Hide until measured, or it flashes at the previous position
      this.#bubble.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') this.#bubble.style.visibility = 'hidden';
        },
        { signal }
      );

      this.#bubble.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.#bubble.style.visibility = '';
            this.#trackWhileOpen();
          } else {
            this.#openAbortController?.abort();
            this.#openAbortController = null;
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      if (openTooltip === this) openTooltip = null;
      this.#abortController?.abort();
      this.#openAbortController?.abort();
      clearTimeout(this.#showTimeout);
    }

    #trackWhileOpen() {
      this.#openAbortController?.abort();
      this.#openAbortController = new AbortController();

      window.addEventListener('resize', () => this.#position(), {
        passive: true,
        signal: this.#openAbortController.signal,
      });

      document.addEventListener('keydown', (event) => event.key === 'Escape' && this.#hide(), {
        signal: this.#openAbortController.signal,
      });
    }

    // The focusable element is usually nested (a radio inside a label)
    #wireDescription() {
      if (this.#bubble.getAttribute('aria-hidden') === 'true') return;

      const describable = this.#trigger.querySelector(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (describable && !describable.hasAttribute('aria-describedby')) {
        describable.setAttribute('aria-describedby', this.#bubble.id);
      }
    }

    #scheduleShow() {
      // Tapping fires a synthetic mouseenter; only real hover should open
      if (!FINE_POINTER.matches) return;

      clearTimeout(this.#showTimeout);

      if (Date.now() < warmUntil) {
        this.#show();
        return;
      }

      this.#showTimeout = setTimeout(() => this.#show(), this.#delay);
    }

    #show() {
      clearTimeout(this.#showTimeout);
      if (this.#bubble.matches(':popover-open')) return;

      openTooltip?.#hide();
      openTooltip = this;

      this.setAttribute('placement', this.#placement);
      this.#bubble.showPopover();
    }

    #hide() {
      clearTimeout(this.#showTimeout);
      if (openTooltip === this) openTooltip = null;
      if (!this.#bubble.matches(':popover-open')) return;

      this.#bubble.hidePopover();
      this.setAttribute('placement', this.#placement);
      warmUntil = Date.now() + WARM_WINDOW;
    }

    #position() {
      const anchor = this.#trigger.getBoundingClientRect();
      const width = this.#bubble.offsetWidth;
      const height = this.#bubble.offsetHeight;
      const offset = parseFloat(getComputedStyle(this.#bubble).getPropertyValue('--kit-tooltip-offset')) || 0;
      const vw = document.documentElement.clientWidth;
      const vh = document.documentElement.clientHeight;

      let placement = this.#placement;
      let box = this.#boxFor(placement, anchor, width, height, offset);

      if (!this.#fits(box, width, height, vw, vh)) {
        const flipped = this.#boxFor(FLIPS[placement], anchor, width, height, offset);

        if (this.#fits(flipped, width, height, vw, vh)) {
          placement = FLIPS[placement];
          box = flipped;
        }
      }

      this.setAttribute('placement', placement);

      const left = clamp(box.left, VIEWPORT_MARGIN, Math.max(VIEWPORT_MARGIN, vw - VIEWPORT_MARGIN - width));
      const top = clamp(box.top, VIEWPORT_MARGIN, Math.max(VIEWPORT_MARGIN, vh - VIEWPORT_MARGIN - height));

      this.#bubble.style.left = `${Math.round(left + window.scrollX)}px`;
      this.#bubble.style.top = `${Math.round(top + window.scrollY)}px`;

      this.#positionArrow(placement, anchor, { height, left, top, width });
    }

    // Keep the arrow on the trigger after clamping
    #positionArrow(placement, anchor, box) {
      const isVertical = placement === 'top' || placement === 'bottom';
      const anchorCenter = isVertical ? anchor.left + anchor.width / 2 : anchor.top + anchor.height / 2;
      const bubbleCenter = isVertical ? box.left + box.width / 2 : box.top + box.height / 2;
      const limit = Math.max(0, (isVertical ? box.width : box.height) / 2 - MIN_ARROW_INSET);

      this.#bubble.style.setProperty('--arrow-offset', `${clamp(anchorCenter - bubbleCenter, -limit, limit)}px`);
    }

    #boxFor(placement, anchor, width, height, offset) {
      // start/end are logical, so they swap sides in RTL
      const beforeAnchor = anchor.left - offset - width;
      const afterAnchor = anchor.right + offset;
      const centeredTop = anchor.top + anchor.height / 2 - height / 2;

      switch (placement) {
        case 'bottom':
          return { left: anchor.left + anchor.width / 2 - width / 2, top: anchor.bottom + offset };
        case 'start':
          return { left: this.#isRTL ? afterAnchor : beforeAnchor, top: centeredTop };
        case 'end':
          return { left: this.#isRTL ? beforeAnchor : afterAnchor, top: centeredTop };
        default:
          return { left: anchor.left + anchor.width / 2 - width / 2, top: anchor.top - offset - height };
      }
    }

    #fits(box, width, height, vw, vh) {
      if (this.#placement === 'top' || this.#placement === 'bottom') {
        return box.top >= VIEWPORT_MARGIN && box.top + height <= vh - VIEWPORT_MARGIN;
      }

      return box.left >= VIEWPORT_MARGIN && box.left + width <= vw - VIEWPORT_MARGIN;
    }
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  customElements.define('kit-tooltip', KitTooltip);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-cart-later"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-cart-later')) {
    const cartMutations = window.mfmCartMutations || (window.mfmCartMutations = {
      queue: Promise.resolve(), pending: 0, refreshing: false, locked: new Map(),
      lock() {
        if (!this.pending && !this.refreshing) return;
        document.querySelectorAll('form[data-location] [data-products], form[data-location] mfm-rush-option').forEach(element => {
          if (!this.locked.has(element)) this.locked.set(element, element.inert);
          element.inert = true;
        });
      },
      holdForReload() {
        this.refreshing = true;
        document.documentElement.setAttribute('data-mfm-cart-pending', '');
        this.lock();
      },
      enqueue(operation) {
        this.pending++;
        document.documentElement.setAttribute('data-mfm-cart-pending', '');
        this.lock();
        const result = this.queue.catch(() => {}).then(operation);
        this.queue = result.catch(() => {});
        return result.finally(() => {
          this.pending--;
          if (!this.pending && !this.refreshing) {
            document.documentElement.removeAttribute('data-mfm-cart-pending');
            this.locked.forEach((inert, element) => { if (element.isConnected) element.inert = inert; });
            this.locked.clear();
          }
        });
      }
    });
    customElements.define('mfm-cart-later', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.checkbox = this.querySelector('input');
        this.status = this.querySelector('[data-status]');
        this.checkbox.addEventListener('change', () => this.save(), {signal:this.controller.signal});
      }
      propertiesMatch(left, right) {
        const normalize = value => JSON.stringify(Object.entries(value || {}).filter(([,v]) => v !== '' && v != null).sort(([a],[b]) => a.localeCompare(b)));
        return normalize(left) === normalize(right);
      }
      matchingLine(cart, properties) {
        const lines = cart.items.filter(line => line.variant_id === Number(this.dataset.variant) && Number(line.selling_plan_allocation?.selling_plan?.id || 0) === Number(this.dataset.plan) && this.propertiesMatch(line.properties, properties));
        return lines.length === 1 ? lines[0] : null;
      }
      async readCart() {
        const response = await fetch(this.dataset.cartUrl, {cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Cart read failed');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
        return cart;
      }
      async save() {
        if (this.busy) return;
        const checked = this.checkbox.checked;
        if (document.documentElement.hasAttribute('data-mfm-saving') || document.documentElement.hasAttribute('data-mfm-save-error')) {
          this.checkbox.checked = !checked;
          return;
        }
        let prior = JSON.parse(this.dataset.properties || '{}');
        let desired = {...prior, Personalization:checked ? this.dataset.pending : ''};
        let confirmed = null;
        let attempted = false;
        let expectedDesired = 0;
        let expectedPrior = 0;
        const quantityFor = (cart, properties) => cart.items.filter(line => line.variant_id === Number(this.dataset.variant) && Number(line.selling_plan_allocation?.selling_plan?.id || 0) === Number(this.dataset.plan) && this.propertiesMatch(line.properties, properties)).reduce((sum,line) => sum + line.quantity,0);
        const verify = cart => {
          const result = this.matchingLine(cart, desired);
          return attempted && result && quantityFor(cart,desired) === expectedDesired && (this.propertiesMatch(prior,desired) || quantityFor(cart,prior) === expectedPrior) ? result : null;
        };
        this.busy = true;
        document.documentElement.setAttribute('data-mfm-saving','');
        this.setAttribute('data-mfm-saving','');
        this.removeAttribute('data-mfm-save-error');
        this.querySelector('[data-refresh]').hidden = true;
        const controls = [...document.querySelectorAll('mfm-cart-later input')].map(input => [input,input.disabled]);
        controls.forEach(([input]) => { input.disabled = true; });
        this.status.textContent = this.dataset.saving;
        return cartMutations.enqueue(async () => {
        try {
          const cart = await this.readCart();
          const item = cart.items.find(line => line.key === this.dataset.key) || this.matchingLine(cart, prior);
          if (!item) throw new Error('Cart line changed');
          prior = {...item.properties};
          desired = {...item.properties, Personalization:checked ? this.dataset.pending : ''};
          expectedDesired = quantityFor(cart,desired) + (this.propertiesMatch(item.properties,desired) ? 0 : item.quantity);
          expectedPrior = quantityFor(cart,prior) - (this.propertiesMatch(item.properties,desired) ? 0 : item.quantity);
          attempted = true;
          const response = await fetch(this.dataset.changeUrl, {
            method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({id:item.key,quantity:item.quantity,properties:desired})
          });
          if (!response.ok) throw new Error('Cart change failed');
          const updated = await response.json();
          confirmed = verify(updated);
          if (!confirmed) throw new Error('Cart change unconfirmed');
        } catch {
          try {
            const cart = await this.readCart();
            confirmed = verify(cart);
            if (!confirmed) {
              const actual = this.matchingLine(cart, prior);
              if (actual) this.checkbox.checked = actual.properties?.Personalization === this.dataset.pending;
            }
          } catch {}
        }
        if (confirmed) {
          this.dataset.key = confirmed.key;
          this.dataset.properties = JSON.stringify(confirmed.properties || {});
          this.checkbox.checked = confirmed.properties?.Personalization === this.dataset.pending;
          this.status.textContent = this.dataset.saved;
          const note = this.closest('form')?.querySelector('[name="note"]');
          try {
            if (note && note.value !== note.defaultValue) sessionStorage.setItem('mfm-cart-note-draft',JSON.stringify({value:note.value,original:note.defaultValue,at:Date.now()}));
          } catch {
            document.documentElement.removeAttribute('data-mfm-saving');
            document.documentElement.setAttribute('data-mfm-save-error','');
            this.removeAttribute('data-mfm-saving');
            document.documentElement.setAttribute('data-mfm-save-reason',this.dataset.savedNote);
            this.setAttribute('data-mfm-save-error','');
            this.status.textContent = this.dataset.savedNote;
            this.querySelector('[data-refresh]').hidden = false;
            return;
          }
          cartMutations.holdForReload();
          window.location.reload();
          return;
        }
        document.documentElement.setAttribute('data-mfm-save-error','');
        document.documentElement.removeAttribute('data-mfm-saving');
        this.setAttribute('data-mfm-save-error','');
        this.removeAttribute('data-mfm-saving');
        this.status.textContent = this.dataset.error;
        this.querySelector('[data-refresh]').hidden = false;
        this.busy = false;
        controls.forEach(([input,disabled]) => { if (input.isConnected) input.disabled = disabled; });
        }).finally(() => {
          if (this.isConnected && this.hasAttribute('data-mfm-save-error')) this.status.focus();
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-cart-readiness"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-cart-readiness')) {
    customElements.define('mfm-cart-readiness', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.controller = new AbortController();
        this.gate = this.form.querySelector('[data-personalization-checkout]');
        this.message = this.querySelector('[role="alert"]');
        try {
          const draft = JSON.parse(sessionStorage.getItem('mfm-cart-note-draft') || 'null');
          if (draft && Date.now() - draft.at < 60000) document.querySelectorAll('form[data-location] [name="note"]').forEach(note => {if (note.value === draft.original) note.value = draft.value;});
          sessionStorage.removeItem('mfm-cart-note-draft');
        } catch {}
        this.update = () => {
          window.mfmCartMutations?.lock();
          const saving = Boolean(document.querySelector('[data-mfm-saving], [data-mfm-cart-pending]'));
          const error = Boolean(document.querySelector('[data-mfm-save-error]'));
          const missing = Boolean(this.form.querySelector('[data-products] [data-mfm-missing]'));
          const rushBlocked = document.documentElement.hasAttribute('data-mfm-rush-blocked');
          const blocked = saving || error || rushBlocked || missing;
          const text = saving ? this.dataset.saving : error ? (document.documentElement.getAttribute('data-mfm-save-reason') || this.dataset.error) : rushBlocked ? document.documentElement.getAttribute('data-mfm-rush-reason') : this.dataset.missing;
          if (this.message.textContent !== text) this.message.textContent = text;
          this.message.hidden = !blocked;
          if (this.gate) this.gate.inert = false;
          this.form.querySelectorAll('.additional-checkout-buttons').forEach(element => {element.inert = blocked;});
          return blocked;
        };
        const intercept = event => {
          const checkout = event.type === 'submit' ? event.target === this.form && event.submitter?.name === 'checkout' : this.form.contains(event.target) && event.target.closest('[name="checkout"]');
          if (checkout && this.update()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.message.focus();
            this.message.scrollIntoView({block:'center',behavior:'smooth'});
          }
        };
        window.addEventListener('click',intercept,{capture:true,signal:this.controller.signal});
        window.addEventListener('submit',intercept,{capture:true,signal:this.controller.signal});
        this.observer = new MutationObserver(this.update);
        this.observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['data-mfm-missing','data-mfm-saving','data-mfm-save-error','data-mfm-cart-pending','data-mfm-rush-blocked','data-mfm-rush-reason']});
        this.update();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-cart-support"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-shipping-progress')) {
    customElements.define('mfm-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.revision = 0;
        this.threshold = Number(this.dataset.threshold);
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD'});
        this.message = this.querySelector('[data-mfm-progress-message]');
        this.remaining = this.querySelector('[data-mfm-remaining]');
        document.addEventListener('cart:updated', () => this.refresh(), {signal:this.controller.signal});
        try { this.update(JSON.parse(this.querySelector('script').textContent)); }
        catch { this.message.textContent = this.dataset.fallback; }
      }
      async refresh() {
        const revision = ++this.revision;
        this.message.textContent = this.dataset.fallback;
        this.remaining.hidden = true;
        this.remaining.textContent = '';
        try {
          const root = this.dataset.root.replace(/\/?$/, '/');
          const response = await fetch(root + 'cart.js', {cache:'no-store',signal:this.controller.signal,headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (revision === this.revision) this.update(cart);
        } catch {
          if (revision === this.revision) this.message.textContent = this.dataset.fallback;
        }
      }
      update(cart) {
        let message = this.dataset.fallback;
        let remaining = '';
        if (Array.isArray(cart.items) && cart.items.length && Number.isSafeInteger(cart.total_price) && cart.total_price >= 0) {
          const physical = cart.items.filter(item => item.requires_shipping && ![50552666783883,50552734056587].includes(item.variant_id));
          if (!physical.length) {
            message = this.dataset.none;
          } else if (cart.currency === 'USD' && this.dataset.country === 'US' && physical.every(item => Number.isFinite(item.grams) && item.grams >= 0 && Number.isInteger(item.quantity) && item.quantity > 0)) {
            const grams = physical.reduce((total,item) => total + item.grams * item.quantity, 0);
            const pounds = grams / 453.59237;
            const rate = pounds <= 1 ? 599 : pounds <= 4 ? 1299 : pounds <= 10 ? 1699 : 2500;
            message = cart.total_price >= this.threshold ? this.dataset.free : this.dataset.paid.replace('[amount]', this.format.format(rate / 100));
            if (cart.total_price < this.threshold) remaining = this.dataset.remaining.replace('[remaining]', this.format.format((this.threshold - cart.total_price) / 100));
          }
        }
        this.message.textContent = message;
        this.remaining.textContent = remaining;
        this.remaining.hidden = !remaining;
      }
      disconnectedCallback() { this.revision++; this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-item-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-item-summary')) {
    customElements.define('mfm-item-summary', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = document.getElementById(this.dataset.formId);
        this.container = this.closest('.product-section');
        if (!this.form || !this.container) return;
        this.variants = JSON.parse(this.querySelector('[data-item-variants]').textContent);
        this.names = JSON.parse(this.querySelector('[data-item-options]').textContent);
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency});
        this.inputs = [...this.container.querySelectorAll('[data-variant-input]')].filter(input => input.getAttribute('form') === this.dataset.formId);
        this.inputs.forEach(input => input.closest('.variant-wrapper')?.classList.add('mfm-readable-options'));
        this.container.addEventListener('change', () => queueMicrotask(() => this.update()), {signal:this.controller.signal});
        this.update();
      }
      update() {
        const choices = [];
        this.inputs.filter(input => input.tagName === 'SELECT' || input.checked).forEach(input => {
          choices[Number(input.dataset.index.replace('option','')) - 1] = input.value;
        });
        const current = this.inputs.length ? this.variants.find(variant => variant.options.every((value,index) => value === choices[index])) : this.variants[0];
        this.querySelector('[data-item-price]').textContent = current?.available ? this.format.format(current.price / 100) + ' ' + this.dataset.currency : this.dataset.unavailable;
        const list = this.querySelector('[data-item-choices]');
        if (list) list.replaceChildren(...choices.map((value,index) => {
          const item = document.createElement('li');
          item.textContent = this.names[index] + ': ' + value;
          return item;
        }));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-personalization-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-personalization-guard')) {
    customElements.define('mfm-personalization-guard', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.later = this.querySelector('[data-mfm-later]');
        this.error = this.querySelector('[data-mfm-error]');
        this.later.addEventListener('change', () => {
          this.error.hidden = true;
        }, { signal });
        const intercept = event => {
          if (!this.form.contains(event.target)) return;
          if (event.type === 'click' && !event.target.closest('[data-add-to-cart]')) return;
          if (this.later.checked) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.submitDeferred();
            return;
          }
          const message = this.validationMessage();
          if (!message) { this.error.hidden = true; return; }
          event.preventDefault();
          event.stopImmediatePropagation();
          this.error.textContent = message;
          this.error.hidden = false;
          this.error.focus();
        };
        window.addEventListener('click', intercept, { capture:true, signal });
        window.addEventListener('submit', intercept, { capture:true, signal });
        window.addEventListener('pageshow', () => { this.submitting = false; }, { signal });
        const updateButton = () => {
          const button = this.form.querySelector('.pplr-c-button.pplr_remove');
          if (button && button.textContent !== this.dataset.clearLabel) button.textContent = this.dataset.clearLabel;
        };
        this.observer = new MutationObserver(updateButton);
        this.observer.observe(this.form, { childList:true, subtree:true });
        updateButton();
      }
      submitDeferred() {
        if (this.submitting) return;
        const button = this.form.querySelector('[data-add-to-cart]');
        if (button?.disabled) return;
        const data = new FormData(this.form);
        if (!/^\d+$/.test(String(data.get('id') || ''))) return;
        this.submitting = true;
        try {
          HTMLFormElement.prototype.submit.call(this.form);
        } catch {
          this.submitting = false;
          this.error.textContent = this.dataset.openError;
          this.error.hidden = false;
          this.error.focus();
        }
      }

      validationMessage() {
        if (this.later.checked || this.dataset.validate !== 'true') return '';
        const app = this.form.querySelector('.product-personalizer');
        const name = app && app.querySelector('input[name="properties[Name of Pet]"], input[name="properties[Name]"], input[name="properties[Pet Name]"]');
        if (!name || name.disabled) return this.dataset.openError;
        if (!name.value.trim() || name.value.trim() === 'Pet Name') return this.dataset.nameError;
        const photoFields = [...app.querySelectorAll('[name="properties[Pet Photo:]"]')];
        if (this.dataset.granite === 'outdoor-black-granite' && photoFields.length === 0) return '';
        const hasPhoto = photoFields.some(field => field.type === 'file' ? field.files.length > 0 : /^https?:\/\//.test(field.value || ''));
        const uploadedImage = [...app.querySelectorAll('.img_url, .crop_img_url')].some(img => {
          const source = img.getAttribute('src') || '';
          return source && !source.includes('/blank.png') && /^(https?:|data:image|blob:)/.test(source);
        });
        if (!hasPhoto && !uploadedImage) return this.dataset.photoError;
        return '';
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-product-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-product-shipping')) {
    customElements.define('mfm-product-shipping', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = document.getElementById(this.dataset.formId);
        this.container = this.closest('.product-section');
        if (!this.form || !this.container) return;
        this.variants = JSON.parse(this.querySelector('script').textContent);
        this.inputs = [...this.container.querySelectorAll('[data-variant-input]')].filter(input => input.getAttribute('form') === this.dataset.formId);
        this.container.addEventListener('change', () => queueMicrotask(() => this.update()), {signal: this.controller.signal});
        this.update();
      }
      update() {
        const choices = [];
        this.inputs.filter(input => input.tagName === 'SELECT' || input.checked).forEach(input => {
          choices[Number(input.dataset.index.replace('option', '')) - 1] = input.value;
        });
        const selected = this.inputs.length ? this.variants.find(variant => variant.options.every((value, index) => value === choices[index])) : this.variants[0];
        let message = this.dataset.fallback;
        if (selected?.available && selected.requires_shipping && this.dataset.currency === 'USD' && Number.isFinite(selected.weight) && selected.weight >= 0) {
          const pounds = selected.weight / 453.59237;
          const rate = pounds <= 1 ? 5.99 : pounds <= 4 ? 12.99 : pounds <= 10 ? 16.99 : 25;
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: 'USD'}).format(rate);
          const remaining = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: 'USD'}).format(Math.max(0, 15000 - selected.price) / 100);
          message = selected.price >= 15000 ? this.dataset.free : this.dataset.paid.replace('[amount]', amount).replace('[remaining]', remaining);
        }
        this.querySelector('[data-shipping-estimate]').textContent = message;
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-rush-option"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-rush-option')) {
    const cartMutations = window.mfmCartMutations || (window.mfmCartMutations = {
      queue: Promise.resolve(), pending: 0, refreshing: false, locked: new Map(),
      lock() {
        if (!this.pending && !this.refreshing) return;
        document.querySelectorAll('form[data-location] [data-products], form[data-location] mfm-rush-option').forEach(element => {
          if (!this.locked.has(element)) this.locked.set(element, element.inert);
          element.inert = true;
        });
      },
      holdForReload() {
        this.refreshing = true;
        document.documentElement.setAttribute('data-mfm-cart-pending', '');
        this.lock();
      },
      enqueue(operation) {
        this.pending++;
        document.documentElement.setAttribute('data-mfm-cart-pending', '');
        this.lock();
        const result = this.queue.catch(() => {}).then(operation);
        this.queue = result.catch(() => {});
        return result.finally(() => {
          this.pending--;
          if (!this.pending && !this.refreshing) {
            document.documentElement.removeAttribute('data-mfm-cart-pending');
            this.locked.forEach((inert, element) => { if (element.isConnected) element.inert = inert; });
            this.locked.clear();
          }
        });
      }
    });
    customElements.define('mfm-rush-option', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.checkbox = this.querySelector('input');
        this.pickupRemove = this.querySelector('[data-pickup-remove]');
        this.status = this.querySelector('[data-status]');
        this.form = this.closest('form');
        this.cartMode = this.dataset.placement === 'cart';
        if (this.dataset.enabled !== 'true') return;
        this.checkbox.addEventListener('change', () => this.run(this.checkbox.checked), {signal:this.controller.signal});
        this.pickupRemove?.addEventListener('click', () => this.run(false), {signal:this.controller.signal});
        document.addEventListener('cart:updated', () => this.run(null), {signal:this.controller.signal});
        this.run(null);
      }
      async request(path, body) {
        const root = this.dataset.root.replace(/\/?$/, '/');
        const response = await fetch(root + path, body ? {
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(body)
        } : {cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Rush cart request failed');
        return response.json();
      }
      isRush(item) {
        return [Number(this.dataset.variant), Number(this.dataset.highVariant)].includes(item.variant_id);
      }
      tier(cart) {
        if (cart.currency !== 'USD') throw new Error('Rush tiers require USD');
        const totals = cart.items.map(item => item.line_price);
        if (!Number.isSafeInteger(cart.total_price) || totals.some(amount => !Number.isSafeInteger(amount) || amount < 0) || totals.reduce((total, amount) => total + amount, 0) !== cart.total_price) {
          throw new Error('Cannot verify discounted merchandise subtotal');
        }
        const subtotal = cart.items.reduce((total, item, index) => total + (this.isRush(item) ? 0 : totals[index]), 0);
        return subtotal >= 15000 ? Number(this.dataset.highVariant) : Number(this.dataset.variant);
      }
      run(desired) {
        if (this.busy) {
          if (desired !== null || this.rerunDesired === undefined) this.rerunDesired = desired;
          return this.runPromise;
        }
        this.busy = true;
        this.checkbox.disabled = true;
        if (this.pickupRemove) this.pickupRemove.disabled = true;
        this.status.textContent = this.dataset.saving;
        const operation = async () => {
          let cart = await this.request('cart.js');
          const lines = cart.items.filter(item => this.isRush(item));
          const hasPhysical = cart.items.some(item => !this.isRush(item) && item.requires_shipping);
          const wantsRush = desired === null ? lines.length > 0 : desired;
          let changed = false;
          let stable = false;
          let variantId = Number(this.dataset.variant);
          for (let attempt = 0; attempt < 4; attempt++) {
            if (wantsRush || cart.currency === 'USD') variantId = this.tier(cart);
            const current = cart.items.filter(item => this.isRush(item));
            if ((!wantsRush && current.length === 0) || (wantsRush && current.length === 1 && current[0].variant_id === variantId && current[0].quantity === 1)) {
              stable = true;
              break;
            }
            const keep = wantsRush ? current.find(item => item.variant_id === variantId) : null;
            const updates = {};
            current.forEach(item => {
              const quantity = item === keep ? 1 : 0;
              if (item.quantity !== quantity) updates[item.key] = quantity;
            });
            if (Object.keys(updates).length) await this.request('cart/update.js', {updates});
            if (wantsRush && !keep) await this.request('cart/add.js', {items:[{id:variantId,quantity:1}]});
            cart = await this.request('cart.js');
            changed = true;
          }
          if (!stable) throw new Error('Rush tier did not stabilize');
          const count = cart.items.filter(item => this.isRush(item)).reduce((total, item) => total + item.quantity, 0);
          this.querySelector('[data-fee-label]').textContent = variantId === Number(this.dataset.highVariant) ? this.dataset.labelHigh : this.dataset.labelLow;
          this.checkbox.checked = count > 0;
          if (this.pickupRemove) {
            this.pickupRemove.hidden = count === 0;
            this.pickupRemove.disabled = false;
          }
          this.querySelector('[data-production]').textContent = count > 0 ? this.dataset.rush : this.dataset.standard;
          this.status.textContent = count > 0 && !hasPhysical ? this.dataset.orphan : cart.currency !== 'USD' ? this.dataset.currencyError : '';
          if (count > 0 && !hasPhysical) {
            document.documentElement.setAttribute('data-mfm-rush-blocked', '');
            document.documentElement.setAttribute('data-mfm-rush-reason', this.dataset.orphan);
          } else {
            document.documentElement.removeAttribute('data-mfm-rush-blocked');
            document.documentElement.removeAttribute('data-mfm-rush-reason');
          }
          if (this.cartMode && count > 0 && !hasPhysical) {
            this.form.querySelectorAll('.cart__checkout-wrapper').forEach(element => {element.inert = true;});
          } else if (this.cartMode) {
            this.form.querySelectorAll('.cart__checkout-wrapper').forEach(element => {element.inert = false;});
          }
          if (this.cartMode && changed) {cartMutations.holdForReload(); window.location.reload(); return;}
          this.checkbox.disabled = cart.currency !== 'USD';
        };
        this.runPromise = cartMutations.enqueue(operation).catch(() => {
          this.status.textContent = this.dataset.error;
          document.documentElement.setAttribute('data-mfm-rush-blocked', '');
          document.documentElement.setAttribute('data-mfm-rush-reason', this.dataset.error);
          if (this.cartMode) this.form.querySelectorAll('.cart__checkout-wrapper').forEach(element => {element.inert = true;});
          this.checkbox.disabled = true;
        }).finally(() => {
          this.busy = false;
          if (this.rerunDesired !== undefined && !cartMutations.refreshing) {
            const next = this.rerunDesired;
            this.rerunDesired = undefined;
            this.run(next);
          }
        });
        return this.runPromise;
      }
      disconnectedCallback() {this.controller?.abort(); this.controller = null;}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-shared-personalizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-shared-personalizer')) {
customElements.define('mfm-shared-personalizer', class extends HTMLElement {
 connectedCallback() {
  if(this.observer) return;
  this.copy=JSON.parse(this.querySelector('[data-shared-copy]').textContent);
  this.controller=new AbortController();
  this.initializedDates=new WeakSet();
  this.observer=new MutationObserver(()=>this.schedule());
  this.observer.observe(document.body,{childList:true,subtree:true});
  for(const event of ['input','change','click']) document.addEventListener(event,e=>{if(e.target.closest('.mfm-zepto')) this.schedule();},{signal:this.controller.signal});
  this.enhance();
 }
 schedule(){ if(this.pending) return; this.pending=requestAnimationFrame(()=>{this.pending=0;this.enhance();}); }
 enhance(){
  const modal=document.querySelector('#pplr_html');
  if(modal?.querySelector('.pplr-wrapper')) {
   modal.classList.add('mfm-zepto');
   modal.closest('.pplr-modal-box')?.classList.add('mfm-preview');
   if(!modal.querySelector('.mfm-preview-intro')){
    const intro=document.createElement('div');intro.className='mfm-preview-intro';
    const title=document.createElement('h3'),help=document.createElement('p');title.textContent=this.copy.preview;help.textContent=this.copy.previewHelp;intro.append(title,help);modal.prepend(intro);
   }
   modal.querySelectorAll('.pplr-wrapper').forEach((wrap,index)=>{
    const field=wrap.querySelector('input:not([type=hidden]),textarea');
    const label=wrap.querySelector('.pplrlabel');
    if(field && label){
     if(!field.id)field.id='mfm-preview-field-'+index;
     label.htmlFor=field.id;
     const property=field.name;
     const text=property==='properties[Name]'?this.copy.name:property==='properties[Date]'&&!field.required?this.copy.dates:['properties[Upload Image]','properties[Image Upload]'].includes(property)?this.copy.photo:'';
     if(text&&!label.dataset.mfmLabel){Array.from(label.childNodes).filter(n=>n.nodeType===3).forEach(n=>n.remove());label.prepend(document.createTextNode(text+' '));label.dataset.mfmLabel='true';}
     if(property==='properties[Date]'&&!wrap.querySelector('.mfm-preview-date-help')){const help=document.createElement('p');help.className='mfm-preview-date-help';help.id=field.id+'-help';help.textContent=this.copy.dateHelp;wrap.append(help);field.setAttribute('aria-describedby',help.id);}
    }
   });
   modal.querySelectorAll('.textBiggerSmaller a,.pplr-selecter-selected,.pplr-selecter-item').forEach(control=>{
    control.tabIndex=0;control.setAttribute('role','button');
    if(control.title)control.setAttribute('aria-label',control.title);
    if(!control.dataset.mfmKeys){control.dataset.mfmKeys='true';control.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();control.click();}},{signal:this.controller.signal});}
   });
  }

  document.querySelectorAll('[id^="pplr-"]').forEach(app=>{
   if(!app.querySelector('.cstmfy_personalize_text, .pplr-c-button')) return;
   app.classList.add('mfm-zepto');
   app.closest('.product-section')?.classList.add('mfm-shared-pilot');
   if(!app.querySelector('.mfm-shared-intro')) app.prepend(this.querySelector('[data-shared-intro]').content.cloneNode(true));
   const opener=app.querySelector('.pplr-c-button:not(.pplr_remove)');
   if(opener && opener.textContent!==this.copy.open) opener.textContent=this.copy.open;
   app.querySelectorAll('.pplr-wrapper').forEach((wrap,index)=>{
    if(this.dataset.productId==='6611939786891'){
     const instruction=wrap.querySelector('.cstmfy_static[name="properties[10]"],.cstmfy_static[name="properties[2 line Note]"]');
     if(instruction){
      const help=document.createElement('p');
      help.className='mfm-shared-help';
      help.textContent=instruction.value;
      wrap.append(help);
      instruction.removeAttribute('name');
      instruction.hidden=true;
      const instructionLabel=wrap.querySelector('.pplrlabel');
      if(instructionLabel) instructionLabel.hidden=true;
     }
     const dateFont=wrap.querySelector('input[name="properties[Select a Font for Copy of Second Line (Optional)]"]');
     if(dateFont){
      dateFont.name='properties[Date font]';
      const fontLabel=wrap.querySelector('.pplrlabel');
      if(fontLabel) fontLabel.textContent=this.dataset.dateFont;
     }
    }
    const field=wrap.querySelector('input:not([type=hidden]),textarea,select');
    const label=wrap.querySelector('.pplrlabel');
    if(this.dataset.productId==='6611939786891' && field && /date/i.test(field.name) && !this.initializedDates.has(field)){
     this.initializedDates.add(field);
     if(field.defaultValue==='2010-2025'){
      if(field.value===field.defaultValue){field.value='';field.placeholder='2010-2025';}
      field.defaultValue='';
     }
    }
    if(field && label){
     const property=field.name;
     const normalized=property==='properties[Name]' || property==='properties[Name of Pet]' ? this.copy.name : ['properties[Dates]','properties[Date]'].includes(property) && !field.required ? this.copy.dates : ['properties[Notes]','properties[Notes for Order]'].includes(property) && !field.required ? this.copy.notes : '';
     if(normalized && !label.dataset.mfmLabel){
      Array.from(label.childNodes).filter(n=>n.nodeType===3 || (n.nodeType===1 && n.tagName==='STRONG')).forEach(n=>n.remove());
      label.prepend(document.createTextNode(normalized+' '));label.dataset.mfmLabel='true';
     }

     if(!field.id) field.id=`mfm-${app.id}-${index}`;
     label.htmlFor=field.id;
     const help=wrap.querySelector('.pplr_ins');
     if(help){ if(!help.id) help.id=field.id+'-help'; field.setAttribute('aria-describedby',help.id); }
    }
    wrap.querySelectorAll('.pplr-drop-item').forEach(choice=>{
     choice.setAttribute('role','button');choice.tabIndex=0;
     choice.setAttribute('aria-pressed',String(choice.classList.contains('active')));
     if(!choice.dataset.mfmKeys){
      choice.dataset.mfmKeys='true';
      choice.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();choice.click();}},{signal:this.controller.signal});
     }
    });
   });
   const fields=app.querySelector('.cstmfy_personalize_text');
   if(!fields?.querySelector('.pplr-wrapper')) return;
   if(!fields.querySelector('.mfm-shared-review')) fields.append(this.querySelector('[data-shared-review]').content.cloneNode(true));
   const rows=[];
   fields.querySelectorAll('.pplr-wrapper').forEach(wrap=>{
    if(wrap.querySelector('.cstmfy_static[hidden]')) return;
    if(wrap.hidden || !wrap.getClientRects().length || getComputedStyle(wrap).display==='none') return;
    const label=wrap.querySelector('.pplrlabel');
    if(!label) return;
    const title=Array.from(label.childNodes).filter(n=>!(n.nodeType===1 && (n.classList.contains('pplr_option_text_span')||n.classList.contains('pplr_option_price_span')))).map(n=>n.textContent).join('').trim();
    const input=wrap.querySelector('input:not([type=hidden]):not([type=file]),textarea,select');
    const file=wrap.querySelector('input[type=file]');
    const choice=wrap.querySelector('.pplr-drop-item.active');
    let value=choice?.textContent.trim() || (input && !['radio','checkbox'].includes(input.type) ? input.value.trim() : '');
    if(file?.files?.length) value=Array.from(file.files).map(f=>f.name).join(', ');
    if(value && title) rows.push([title,value]);
   });
   const list=fields.querySelector('.mfm-shared-review dl');
   const signature=JSON.stringify(rows);
   if(list.dataset.values!==signature){
    list.dataset.values=signature;list.replaceChildren();
    rows.forEach(([title,value])=>{const row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=title;dd.textContent=value;row.append(dt,dd);list.append(row);});
   }
  });
 }
 disconnectedCallback(){this.observer?.disconnect();this.observer=null;this.controller?.abort();cancelAnimationFrame(this.pending);}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-upgrade-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-upgrade-guide')) {
    customElements.define('mfm-upgrade-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.container = this.closest('.product-section');
        if (!this.container) return;
        this.controller = new AbortController();
        this.variants = JSON.parse(this.querySelector('[data-mfm-variants]').textContent);
        this.rules = [...this.querySelectorAll('[data-mfm-rule]')].map(element => JSON.parse(element.textContent));
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency});
        this.inputs = [...this.container.querySelectorAll('[data-variant-input]')].filter(input => input.getAttribute('form') === this.dataset.formId);
        this.inputs.forEach(input => {
          input.closest('.variant-wrapper')?.classList.add('mfm-guided-options');
          input.addEventListener('change', () => this.update(), {signal:this.controller.signal});
        });
        const groups = [...new Set(this.inputs.map(input => input.closest('.variant-wrapper')))];
        groups.forEach((group, index) => {
          const label = group.querySelector('.variant__label');
          const fieldset = group.querySelector('fieldset');
          if (!label || !fieldset) return;
          const name = fieldset.getAttribute('name') || '';
          const lower = name.toLowerCase();
          const title = lower.includes('size') ? this.dataset.sizeStep : (lower.includes('engrav') || lower === 'finish') ? this.dataset.engravingStep : lower.includes('photo') ? this.dataset.photoStep : name;
          const node = [...label.childNodes].find(child => child.nodeType === Node.TEXT_NODE && child.textContent.trim());
          if (node) node.textContent = `${index + 1}. ${title} `;
        });
        const heading = this.container.querySelector('.mfm-personalization__heading');
        if (heading) heading.textContent = `${groups.length + 1}. ${this.dataset.personalizeStep}`;
        this.update();
      }
      matches(rule, value) {
        const needle = (rule.match || '').trim().toLowerCase();
        const text = value.trim().toLowerCase();
        return !!needle && (rule.mode === 'exact' ? text === needle : text.includes(needle));
      }
      update() {
        this.querySelectorAll('[data-mfm-guidance]').forEach(paragraph => {
          const rule = this.rules.find(item => item.id === paragraph.dataset.mfmGuidance);
          paragraph.hidden = !rule || !this.inputs.some(input => this.matches(rule, input.value));
        });
        const details = this.querySelector('details');
        details.hidden = !this.querySelector('[data-mfm-static-guidance]') && ![...this.querySelectorAll('[data-mfm-guidance]')].some(paragraph => !paragraph.hidden);
        const selected = [];
        this.inputs.filter(input => input.checked).forEach(input => selected[Number(input.dataset.index.replace('option','')) - 1] = input.value);
        const current = this.variants.find(v => v.options.every((option,i) => option === selected[i]));
        const form = document.getElementById(this.dataset.formId);
        const summary = form?.querySelector('[data-mfm-summary]');
        if (summary) {
          summary.querySelector('[data-mfm-total]').textContent = current?.available ? this.format.format(current.price / 100) : this.dataset.unavailable;
          const list = summary.querySelector('[data-mfm-choices]');
          list.replaceChildren(...selected.map((value, index) => {
            const item = document.createElement('li');
            const input = this.inputs.find(candidate => Number(candidate.dataset.index.replace('option','')) - 1 === index);
            item.textContent = `${input?.closest('fieldset')?.getAttribute('name') || ''}: ${value}`;
            return item;
          }));
        }
        this.inputs.forEach(input => {
          const label = input.parentElement.querySelector('label');
          if (!label) return;
          const rule = this.rules.find(item => this.matches(item, input.value));
          let benefit = label.querySelector('.mfm-option-benefit');
          if (rule?.description?.trim()) {
            if (!benefit) {
              benefit = document.createElement('span');
              benefit.className = 'mfm-option-benefit';
              label.append(benefit);
            }
            benefit.textContent = rule.description;
          } else benefit?.remove();
          let price = label.querySelector('.mfm-option-price');
          if (!price) { price = document.createElement('span'); price.className = 'mfm-option-price'; label.append(price); }
          const choices = [...selected];
          choices[Number(input.dataset.index.replace('option','')) - 1] = input.value;
          const match = this.variants.find(v => v.options.every((option,i) => option === choices[i]));
          if (!match || !match.available) price.textContent = this.dataset.unavailable;
          else price.textContent = `${input.checked ? '✓ ' + this.dataset.selected + ' · ' : ''}${this.dataset.priceLabel} ${this.format.format(match.price / 100)}`;
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-variant-badge-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-variant-badge-controller')) {
  customElements.define('mfm-variant-badge-controller', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.container = this.closest('.product-section');
      if (!this.container) return;
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.container.addEventListener('change', () => this.update(), {signal:this.controller.signal});
      this.update();
    }
    update() {
      const inputs = [...this.container.querySelectorAll('[data-variant-input]')].filter(input => input.getAttribute('form') === this.dataset.formId);
      const selected = [];
      const indexOf = input => Number(input.dataset.index.replace('option', '')) - 1;
      inputs.filter(input => input.tagName === 'SELECT' || input.checked).forEach(input => selected[indexOf(input)] = input.value);
      const badgesFor = (index, value) => {
        const choices = [...selected];
        choices[index] = value;
        const variant = this.variants.find(item => item.options.every((option, i) => option === choices[i]));
        return Array.isArray(variant?.badges) ? variant.badges.map(text => String(text).trim()).filter(Boolean) : [];
      };
      inputs.forEach(input => {
        if (input.tagName === 'SELECT') {
          [...input.options].forEach(option => {
            option.textContent = option.value + badgesFor(indexOf(input), option.value).map(text => ' — ' + text).join('');
          });
          return;
        }
        const holder = input.closest('.variant-input')?.querySelector('.mfm-variant-badges');
        if (!holder) return;
        const badges = badgesFor(indexOf(input), input.value);
        holder.replaceChildren(...badges.map(text => {
          const badge = document.createElement('span');
          badge.className = 'mfm-variant-badge';
          badge.textContent = text;
          return badge;
        }));
        holder.hidden = badges.length === 0;
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-wood-cart-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-wood-cart-guard')) {
    customElements.define('mfm-wood-cart-guard', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.controller = new AbortController();
        this.message = this.querySelector('[role=alert]');
        const signal = this.controller.signal;
        const intercept = event => {
          const button = event.type === 'click' ? event.target.closest('[name=checkout]') : event.submitter;
          if (!this.form.contains(event.target) || button?.name !== 'checkout') return;
          if (this.validated) { this.validated = false; return; }
          event.preventDefault();
          event.stopImmediatePropagation();
          this.checkCheckout(button);
        };
        window.addEventListener('click', intercept, {capture:true,signal});
        window.addEventListener('submit', intercept, {capture:true,signal});
        document.addEventListener('cart:updated', () => this.refresh().catch(() => {}), {signal});
        this.refresh().catch(() => {});
      }
      async refresh() {
        const response = await fetch(this.dataset.cartUrl, {cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('cart');
        const wood = cart.items.filter(item => item.product_id === 10350954381451);
        const eligible = cart.items.some(item => ['Indoor Memorials','Outdoor Memorials'].includes(item.product_type) && item.product_id !== 10350954381451);
        const references = cart.items.filter(item => ['Indoor Memorials','Outdoor Memorials'].includes(item.product_type) && item.product_id !== 10350954381451).map(item => [item.product_title || item.title, item.variant_title, item.properties?.['Name of Pet'] || item.properties?.Name || item.properties?.['Pet Name'] || ''].filter(Boolean).join(' — '));
        const sources = ['Use photo from another memorial in this order','Email a different photo','Text a different photo'];
        const photoMissing = wood.some(item => !sources.includes(item.properties?.['Photo source']) || (item.properties?.['Photo source'] === sources[0] && !references.includes(item.properties?.['Photo reference'])));
        const reason = wood.length && !eligible ? this.dataset.empty : photoMissing ? this.dataset.photo : '';
        this.message.textContent = reason;
        this.message.hidden = !reason;
        this.form.querySelectorAll('.additional-checkout-buttons').forEach(element => {
          if (wood.length) { element.hidden = true; element.dataset.woodHidden = 'true'; }
          else if (element.dataset.woodHidden) { element.hidden = false; delete element.dataset.woodHidden; }
        });
        return reason;
      }
      async checkCheckout(button) {
        if (this.busy) return;
        this.busy = true;
        try {
          const reason = await this.refresh();
          if (reason) { this.message.focus(); return; }
          this.validated = true;
          this.form.requestSubmit(button);
        } catch {
          this.message.textContent = this.dataset.error;
          this.message.hidden = false;
          this.message.focus();
        } finally { this.busy = false; this.validated = false; }
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-wood-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-wood-fields')) {
    customElements.define('mfm-wood-fields', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.source = this.querySelector('[data-wood-source]');
        this.reference = this.querySelector('[data-wood-reference]');
        this.error = this.querySelector('[data-wood-error]');
        const sync = () => {
          const reuse = this.source.selectedIndex === 1;
          this.querySelector('[data-wood-reference-wrap]').hidden = !reuse;
          this.reference.disabled = !reuse;
          this.reference.required = reuse;
          this.error.hidden = true;
        };
        this.source.addEventListener('change', sync, {signal});
        this.form.addEventListener('submit', event => {
          if (this.validated) { this.validated = false; return; }
          event.preventDefault();
          event.stopImmediatePropagation();
          this.validateAndSubmit(event.submitter);
        }, {capture:true,signal});
        this.form.addEventListener('click', event => {
          const button = event.target.closest('[data-add-to-cart]');
          if (!button || this.validated) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.validateAndSubmit(button);
        }, {capture:true,signal});
        sync();
        this.refresh().catch(() => {});
      }
      async refresh() {
        const response = await fetch(this.dataset.cartUrl, {cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('cart');
        const eligible = cart.items.filter(item => ['Indoor Memorials','Outdoor Memorials'].includes(item.product_type) && item.product_id !== 10350954381451);
        const prior = this.reference.value;
        this.reference.replaceChildren(new Option(this.dataset.choose, ''));
        for (const item of eligible) {
          const pet = item.properties?.['Name of Pet'] || item.properties?.Name || item.properties?.['Pet Name'] || '';
          const label = [item.product_title || item.title, item.variant_title, pet].filter(Boolean).join(' — ');
          const option = new Option(label, label);
          this.reference.add(option);
        }
        if ([...this.reference.options].some(option => option.value === prior)) this.reference.value = prior;
        if (eligible.length === 1 && !prior) this.reference.selectedIndex = 1;
        return eligible;
      }
      async validateAndSubmit(button) {
        if (this.busy || button?.disabled) return;
        this.busy = true;
        const showError = text => {
          this.error.textContent = text;
          this.error.hidden = false;
          this.error.focus();
        };
        try {
          const eligible = await this.refresh();
          if (!eligible.length) { showError(this.dataset.empty); return; }
          if (!this.source.value) { showError(this.dataset.required); this.source.focus(); return; }
          if (this.source.selectedIndex === 1 && !this.reference.value) { showError(this.dataset.choose); this.reference.focus(); return; }
          if (!this.form.reportValidity()) return;
          this.error.hidden = true;
          this.validated = true;
          this.form.requestSubmit(button || this.form.querySelector('[data-add-to-cart]'));
        } catch { showError(this.dataset.error); }
        finally { this.busy = false; this.validated = false; }
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mfm-wood-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mfm-wood-offer')) {
    customElements.define('mfm-wood-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.dataset.placement !== 'cart') return;
        this.controller = new AbortController();
        const refresh = async () => {
          try {
            const response = await fetch(this.dataset.cartUrl, {cache:'no-store',headers:{Accept:'application/json'}});
            if (!response.ok) throw new Error('cart');
            const cart = await response.json();
            const hasWood = cart.items.some(item => item.product_id === 10350954381451);
            const eligible = cart.items.some(item => item.product_type === 'Outdoor Memorials' && item.product_id !== 10350954381451);
            this.hidden = hasWood || !eligible;
          } catch { this.hidden = true; }
        };
        let scheduled;
        const schedule = () => { clearTimeout(scheduled); scheduled = setTimeout(refresh, 100); };
        document.addEventListener('cart:updated', schedule, {signal:this.controller.signal});
        document.addEventListener('cart:build', schedule, {signal:this.controller.signal});
        this.observer = new MutationObserver(schedule);
        const items = this.closest('form')?.querySelector('[data-products]');
        if (items) this.observer.observe(items, {childList:true,subtree:true});
        refresh();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

})();
